import AdditionalSingleService from './AdditionalSingleService/AdditionalSingleService';

const AdditionalServices = ({ img, AdditionalServicesData }) => {

    return (
        <section className="pt-135 pb-120">
            <div className="additionalServiceSection__area">
                <div className="tw-container tw-mx-auto">
                    <div className="tw-flex tw-flex-wrap tw--mx-3">
                        <div className="tw-w-full tw-px-3 lg:tw-w-1/2">
                            <div className="text-wrap additionalServiceSection__area__content">
                                {AdditionalServicesData.map((item, index) => {
                                    return <div key={index} className="panel-text">
                                        <AdditionalSingleService icon={item.icon} title={item.title} content={item.content} />
                                    </div>
                                })}
                            </div>
                        </div>

                        <div className="tw-w-full tw-px-3 lg:tw-w-1/2 tw-relative">
                            <div className="imagearea">
                                <div className="p-wrap additionalServiceSection__area__image">
                                    <div className="panel" style={{ background: `url(${img})`, backgroundPosition: 'center', backgroundSize: 'cover' }}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    )
};

export default AdditionalServices;
